import { Select } from "@chakra-ui/react";
import { useAdmins } from "../../../hooks/user.hooks";
import { useOrdersKanbanStore } from "../../../stores/kanban.store";

const OrdersManagerFilter = () => {
	const {
		filters: { modelerId },
		setFilterModelerId,
	} = useOrdersKanbanStore();
	const { data: admins } = useAdmins();

	return (
		<Select
			name="manager"
			value={modelerId ?? ""}
			onChange={(e) => {
				e.preventDefault();
				e.stopPropagation();
				setFilterModelerId(e.target.value);
			}}
			placeholder="Modeleur"
		>
			{admins?.map((admin) => (
				<option key={admin.id} value={admin.id}>
					{admin.email}
				</option>
			))}
		</Select>
	);
};

export default OrdersManagerFilter;
